// ============================================================
// AROGYAMEDS — MOCK DATA (frontend-only teaser)
// All data here will later be replaced by backend APIs.
// ============================================================

const u = (id, w = 600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const pharmacistImg = "https://randomuser.me/api/portraits/women/44.jpg";

// ---------------- HERO SLIDES ----------------
export const heroSlides = [
  {
    badge: "Your Trusted Online Pharmacy",
    titleA: "Genuine Medicines",
    titleB: "Delivered to Your Doorstep",
    sub: "Trusted brands  |  Best prices  |  Fast & safe delivery",
    img: u("photo-1603398938378-e54eab446dde", 900),
  },
  {
    badge: "Flat 15% OFF on First Order",
    titleA: "Health is Wealth —",
    titleB: "Save More on Every Order",
    sub: "Use Code: WELCOME15  |  100% genuine  |  PAN India delivery",
    img: u("photo-1584739555405-37e477519d5e", 900),
  },
  {
    badge: "Upload Prescription",
    titleA: "Expert Pharmacists",
    titleB: "Verify Every Prescription",
    sub: "Upload now  |  Expert verification  |  Doorstep delivery",
    img: u("photo-1676364423874-19c785db3e61", 900),
  },
];

// ---------------- CATEGORIES (Shop by Category page + grid) ----------------
export const categories = [
  { slug: "medicines", name: "Medicines", sub: "Allopathy | OTC | Prescription", img: u("photo-1631549916768-4119b2e5f926"), bg: "#e8f6ec", color: "#0e7a3d", arrow: "#12a150" },
  { slug: "health-wellness", name: "Health & Wellness", sub: "Vitamins | Supplements | Immunity", img: u("photo-1627467959547-8e44da7aa00a"), bg: "#e7f2fd", color: "#0b5fa5", arrow: "#1d7ed0" },
  { slug: "personal-care", name: "Personal Care", sub: "Skincare | Haircare | Hygiene", img: u("photo-1590393802688-ab3fd7c186f2"), bg: "#fdeef5", color: "#b02368", arrow: "#d63384" },
  { slug: "baby-care", name: "Baby Care", sub: "Diapers | Baby Food | Essentials", img: u("photo-1750085036915-6e21c6981586"), bg: "#fdf6df", color: "#b07908", arrow: "#e8a50c" },
  { slug: "health-devices", name: "Health Devices", sub: "BP Monitor | Thermometer | More", img: u("photo-1615486511484-92e172cc4fe0"), bg: "#eceefd", color: "#1e3fae", arrow: "#1e40af" },
  { slug: "diabetes-care", name: "Diabetes Care", sub: "Glucose Monitor | Strips | Accessories", img: u("photo-1684156486280-ff59f07fc5bb"), bg: "#e2f4f2", color: "#0f766e", arrow: "#0f766e" },
  { slug: "nutrition-fitness", name: "Nutrition & Fitness", sub: "Protein | Sports Nutrition | Fitness", img: u("photo-1693996045899-7cf0ac0229c7"), bg: "#fdf1e2", color: "#c2570c", arrow: "#d96c11" },
  { slug: "ayurveda-herbal", name: "Ayurveda & Herbal", sub: "Natural Care | Immunity | Wellness", img: u("photo-1492552296703-4ec0a2fb3715"), bg: "#eaf7e2", color: "#15803d", arrow: "#16a34a" },
  { slug: "sexual-wellness", name: "Sexual Wellness", sub: "Care | Confidence | Well-being", img: u("photo-1763668444855-401b58dceb20"), bg: "#fdeef4", color: "#c2185b", arrow: "#c2185b" },
  { slug: "otc-first-aid", name: "OTC & First Aid", sub: "Pain Relief | Fever | Wound Care", img: "https://images.pexels.com/photos/5149759/pexels-photo-5149759.jpeg?auto=compress&cs=tinysrgb&w=600", bg: "#e9f5fd", color: "#0b5fa5", arrow: "#1565c0" },
];

// ---------------- LEFT SIDEBAR (Home) ----------------
export const sidebarCategories = [
  { name: "All Medicines", icon: "Pill", to: "/category/medicines" },
  { name: "Prescription Medicines", icon: "FileText", to: "/category/medicines" },
  { name: "OTC (Over The Counter)", icon: "ShoppingBag", to: "/category/otc-first-aid" },
  { name: "Health & Wellness", icon: "HeartPulse", to: "/category/health-wellness" },
  { name: "Personal Care", icon: "Sparkles", to: "/category/personal-care" },
  { name: "Baby Care", icon: "Baby", to: "/category/baby-care" },
  { name: "Nutrition & Fitness", icon: "Dumbbell", to: "/category/nutrition-fitness" },
  { name: "Diabetes Care", icon: "Droplet", to: "/category/diabetes-care" },
  { name: "Ayurveda & Herbal", icon: "Leaf", to: "/category/ayurveda-herbal" },
  { name: "Sexual Wellness", icon: "Heart", to: "/category/sexual-wellness" },
  { name: "Medical Devices", icon: "Monitor", to: "/category/health-devices" },
  { name: "First Aid & Emergency", icon: "BriefcaseMedical", to: "/category/otc-first-aid" },
  { name: "Veterinary Care", icon: "PawPrint", to: "/category/health-wellness" },
];

// ---------------- BRANDS ----------------
export const brands = [
  { name: "Cipla", style: "text-[#1a4f9c] font-bold italic" },
  { name: "Mankind", style: "text-[#f26522] font-bold" },
  { name: "Sun Pharma", style: "text-[#d97706] font-bold" },
  { name: "Dr. Reddy's", style: "text-[#1a4f9c] font-semibold" },
  { name: "Abbott", style: "text-[#005eb8] font-extrabold" },
  { name: "Alembic", style: "text-[#0d9488] font-bold italic" },
  { name: "Novo Nordisk", style: "text-[#0033a0] font-semibold" },
  { name: "Zydus", style: "text-[#e31837] font-extrabold italic" },
  { name: "Torrent", style: "text-[#6d28d9] font-bold" },
];

// ---------------- PRODUCTS ----------------
export const bestSellers = [
  { id: 1, name: "Paracetamol 500mg", brand: "Cipla", price: 25, mrp: 28, off: 10, img: u("photo-1550572017-26b5655c1e8c", 300), category: "medicines" },
  { id: 2, name: "Amlodipine 5mg", brand: "Sun Pharma", price: 48, mrp: 55, off: 12, img: u("photo-1584308666744-24d5c474f2ae", 300), category: "medicines" },
  { id: 3, name: "Metformin 500mg", brand: "Glenmark", price: 42, mrp: 46, off: 8, img: u("photo-1631549916768-4119b2e5f926", 300), category: "medicines" },
  { id: 4, name: "ORS Powder", brand: "Wockhardt", price: 32, mrp: 38, off: 15, img: u("photo-1628771065518-0d82f1938462", 300), category: "medicines" },
  { id: 5, name: "Vitamin D3 60K", brand: "Sun Pharma", price: 75, mrp: 83, off: 10, img: u("photo-1664216294580-079bc527ae49", 300), category: "health-wellness" },
  { id: 6, name: "Cetirizine 10mg", brand: "Zydus", price: 35, mrp: 38, off: 8, img: u("photo-1763668444855-401b58dceb20", 300), category: "medicines" },
];

export const newArrivals = [
  { id: 7, name: "Azithromycin 250mg", brand: "Cipla", price: 89, mrp: 105, off: 15, img: u("photo-1584308666744-24d5c474f2ae", 300), category: "medicines" },
  { id: 8, name: "Omega-3 Fish Oil", brand: "HealthKart", price: 499, mrp: 699, off: 28, img: u("photo-1627467959547-8e44da7aa00a", 300), category: "health-wellness" },
  { id: 9, name: "Baby Gentle Wipes", brand: "Johnson's", price: 145, mrp: 180, off: 19, img: u("photo-1750085894110-b2e2f11d5e8b", 300), category: "baby-care" },
  { id: 10, name: "Pulse Oximeter", brand: "BPL", price: 999, mrp: 1499, off: 33, img: u("photo-1626851528990-fee2c2e6fadb", 300), category: "health-devices" },
  { id: 11, name: "Whey Protein 1kg", brand: "Optimum", price: 1899, mrp: 2499, off: 24, img: u("photo-1693996045899-7cf0ac0229c7", 300), category: "nutrition-fitness" },
  { id: 12, name: "Aloe Vera Gel", brand: "Patanjali", price: 99, mrp: 140, off: 29, img: u("photo-1590393802688-ab3fd7c186f2", 300), category: "personal-care" },
];

export const topOffers = [
  { id: 13, name: "Dolo 650mg", brand: "Micro Labs", price: 30, mrp: 34, off: 11, img: u("photo-1550572017-26b5655c1e8c", 300), category: "medicines" },
  { id: 14, name: "Pain Relief Spray", brand: "Sun Pharma", price: 155, mrp: 210, off: 26, img: u("photo-1613803745799-ba6c10aace85", 300), category: "otc-first-aid" },
  { id: 15, name: "Glucometer Kit", brand: "Accu-Chek", price: 899, mrp: 1299, off: 30, img: u("photo-1684156486280-ff59f07fc5bb", 300), category: "diabetes-care" },
  { id: 16, name: "Multivitamin Tablets", brand: "Zydus", price: 250, mrp: 375, off: 33, img: u("photo-1627467959547-8e44da7aa00a", 300), category: "health-wellness" },
  { id: 17, name: "Herbal Immunity Booster", brand: "Himalaya", price: 199, mrp: 275, off: 27, img: u("photo-1492552296703-4ec0a2fb3715", 300), category: "ayurveda-herbal" },
  { id: 18, name: "First Aid Kit", brand: "3M", price: 349, mrp: 499, off: 30, img: "https://images.pexels.com/photos/5149759/pexels-photo-5149759.jpeg?auto=compress&cs=tinysrgb&w=300", category: "otc-first-aid" },
];

export const allProducts = [...bestSellers, ...newArrivals, ...topOffers];

// ---------------- TRUST STRIPS ----------------
export const homeTrust = [
  { icon: "Users", title: "Trusted by 5 Lakh+ Customers", sub: "Across India" },
  { icon: "ShieldCheck", title: "100% Secure Payments", sub: "UPI | Card | Net Banking | COD" },
  { icon: "Truck", title: "PAN India Delivery", sub: "Fast & Reliable" },
  { icon: "Headset", title: "Expert Pharmacist Support", sub: "For a healthier tomorrow" },
];

export const categoriesTrust = [
  { icon: "BadgeCheck", title: "100% Genuine", sub: "Products" },
  { icon: "ShieldCheck", title: "Trusted Pharma", sub: "Brands" },
  { icon: "Truck", title: "PAN India", sub: "Delivery" },
  { icon: "FileBadge", title: "Upload Prescription", sub: "(Expert Verification)" },
  { icon: "BadgePercent", title: "Great Offers", sub: "& Discounts" },
];

// ---------------- WHY CHOOSE ----------------
export const whyChoose = [
  { title: "100% Genuine Products", sub: "Trusted brands only" },
  { title: "Best Prices", sub: "Save more on your health" },
  { title: "Fast & Safe Delivery", sub: "Across India" },
  { title: "Secure Payments", sub: "Multiple payment options" },
];

// ---------------- ORDER TRACKING (mock) ----------------
export const mockOrderSteps = [
  { label: "Order Placed", time: "12 Sep, 10:24 AM", done: true },
  { label: "Packed", time: "12 Sep, 02:10 PM", done: true },
  { label: "Shipped", time: "13 Sep, 09:00 AM", done: true },
  { label: "Out for Delivery", time: "Expected today", done: false, active: true },
  { label: "Delivered", time: "Pending", done: false },
];
